import script from "./productScale.vue?vue&type=script&lang=ts&setup=true"
export * from "./productScale.vue?vue&type=script&lang=ts&setup=true"

import "./productScale.vue?vue&type=style&index=0&id=5fd85abe&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fd85abe"]])

export default __exports__